export interface YesNoOption {
  value: 'yes' | 'no';
  label: 'Yes' | 'No';
  disabled: boolean;
}

export const YES_NO_OPTIONS: readonly YesNoOption[] = [
  { value: 'yes', label: 'Yes', disabled: false },
  { value: 'no', label: 'No', disabled: false },
];
